import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets window scroll position to the top on every route change.
// Skips scrolling when a hash is present so in-page anchors still work.
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;

    // A previous page (e.g. the Home hero) may have locked body scrolling.
    // Make sure scrolling is enabled before we reset the position.
    document.body.style.overflow = "";

    // Reset immediately...
    window.scrollTo(0, 0);

    // ...and again after the new route has painted, so any late layout
    // shifts (images, fonts, animations) can't leave us scrolled down.
    const raf = requestAnimationFrame(() => window.scrollTo(0, 0));
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
